import DiscountCodeService from '../services/discountCode/discountCodeService';
import { DiscountCodeDto } from '../services/discountCode/dto/discountCodeDto';
import { PolicyType } from '../services/policy/policyTypeEnums';
import { CrudStoreBase } from './crudStoreBase';
import { defaultInsurer } from './insurerStore';

class DiscountCodeStore extends CrudStoreBase<DiscountCodeDto>{
  constructor() {
    super(DiscountCodeService, defaultDiscountCode)
  }

  public resetDataSet() {
    this.dataSet = {
        totalCount: 0,
        items: [],
    };
  }
}

export const defaultDiscountCode = {
  id: '',
  code: '',
  isActive: false,
  startDate: '',
  endDate: '',
  segment: PolicyType.Vehicle,
  insurerId: 0,
  insurer: defaultInsurer,
  maxUsageCount: 0,
  countOfUses: 0,
  description: '',
  lastModificationTime: '',
  lastModifierUserId: 0,
  creationTime: '',
  creatorUserId: 0,
}

export default DiscountCodeStore;